// Beta signup form of the mobile app page (pages/mobile_app). Messages come from the form's data-*
// attributes, rendered server side in the page locale: the page loads no JS translations.

const EMAIL_PATTERN = /^[^@\s]+@([^@\s]+\.)+[^@\s]+$/;

export const isValidEmail = (email) => EMAIL_PATTERN.test((email || '').trim());

export const buildSignupPayload = (form) => {
    const data = new FormData(form);
    const payload = {
        email:   (data.get('email') || '').trim(),
        website: data.get('website') || '',
        locale:  form.dataset.locale
    };
    if (data.get('platform')) payload.platform = data.get('platform');
    if (data.get('activity')) payload.activity = data.get('activity');

    return payload;
};

// Resolves with the HTTP status. The page is served from a public cache, so no CSRF token is sent:
// the endpoint does not check it.
export const sendSignup = (payload) => (
    fetch('/api/v1/mobile_beta_signups', {
        method:      'POST',
        credentials: 'same-origin',
        headers:     {Accept: 'application/json', 'Content-Type': 'application/json'},
        body:        JSON.stringify({mobile_beta_signup: payload})
    }).then((response) => response.status)
);

export const initMobileBetaForm = (form, {send = sendSignup, onSuccess} = {}) => {
    if (!form) return;

    const status = form.querySelector('[data-role="status"]');
    const button = form.querySelector('button[type="submit"]');
    const idleLabel = button.textContent;
    const success = form.closest('[data-beta-signup]').querySelector('[data-role="success"]');

    const setBusy = (busy) => {
        button.disabled = busy;
        button.setAttribute('aria-busy', String(busy));
        button.textContent = busy ? form.dataset.busyLabel : idleLabel;
    };

    const fail = (message) => {
        setBusy(false);
        status.textContent = message;
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        const payload = buildSignupPayload(form);
        if (!isValidEmail(payload.email)) {
            form.elements.email.setAttribute('aria-invalid', 'true');
            status.textContent = form.dataset.errorEmail;
            form.elements.email.focus();
            return;
        }

        form.elements.email.removeAttribute('aria-invalid');
        // The invitation goes through Google Play or TestFlight: without the phone it cannot be sent.
        if (!payload.platform) {
            status.textContent = form.dataset.errorPlatform;
            form.querySelector('[name="platform"]')?.focus();
            return;
        }

        status.textContent = '';
        setBusy(true);

        send(payload)
            .then((code) => {
                if (code >= 200 && code < 300) {
                    form.hidden = true;
                    success.hidden = false;
                    success.focus?.();
                    onSuccess?.(form);
                } else if (code === 422) {
                    form.elements.email.setAttribute('aria-invalid', 'true');
                    fail(form.dataset.errorEmail);
                } else {
                    fail(code === 429 ? form.dataset.errorRate : form.dataset.errorGeneric);
                }
            })
            .catch(() => fail(form.dataset.errorGeneric));
    });
};
